<template lang="pug">
.container.cardResgate
  .card
    cadastro-sicarf(titleCadastro="Solicitar resgate de aforamento", routeName="aforamento", :cadastroEmpty="empty", :tabs="tabs")
</template>

<script>
import CadastroSicarf from '@/screens/central/components/CadastroSicarf'
import empty from '../empty/emptyResgateAforamento'

export default {

  components: {
    CadastroSicarf
  },

  data () {
    return {
      // O atributo @name deve ser o mesmo da rota definida no router
      tabs: [
        {
          label: 'Cadastrante',
          name: 'aforamento/cadastrante',
          codigo: 'CADASTRANTE'
        },
        {
          label: 'Interessado',
          name: 'aforamento/interessado',
          codigo: 'INTERESSADO'
        },
        {
          label: 'Imóvel',
          name: 'aforamento/imovel',
          codigo: 'IMOVEL'
        },
        {
          label: 'Georreferenciamento',
          name: 'aforamento/georreferenciamento'
        },
        {
          label: 'Resumo',
          name: 'aforamento/resumo',
          isResumo: true
        }
      ],
      empty: empty
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  .card {
    width: 100%;
  }

  @media (max-width: 780px) {
    .cardResgate {
      position: relative;
      top: 50px;
      right: 60%;
      width: 350px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/resgateAforamento/Cadastro.vue